import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import {States} from "../../shared/config/constant.module";
import template from './shiftDetailReport.tpl.html';
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import PlantServiceName, { PlantService } from '../../services/plant/plant.service';
import {apsViewModels} from '../../shared/dto/APS.ViewModels';
import NotifyServiceName, { NotifyService } from '../../services/notify/notify.service';
import DateUtilityService from '../../services/utility/dateutility.service';

let requires = [LoaderServiceName, ReportServiceName, AuthDataServiceName,
  NavigationServiceName, PlantServiceName, NotifyServiceName];
  
interface ShiftDetailReportController {
  plants: apsViewModels.PlantInfo[];
  selectedPlant: apsViewModels.PlantInfo;
  reportDate: Date;
  selectedShift: Shift;
  shifts: Shift[];
  allShifts: boolean;
  form: angular.IFormController;

  updatePlant(): void;
  getReport(): void;
  shiftChecked(boolean): void
}

interface Shift {
  id: number;
  name: string;
}

class ShiftDetailReportControllerImplementation implements ShiftDetailReportController {
  plants: apsViewModels.PlantInfo[];
  selectedPlant: apsViewModels.PlantInfo;
  reportDate: Date;
  selectedShift: Shift;
  shifts: Shift[];
  allShifts: boolean;
  form: angular.IFormController;

  loaderService: LoaderService;
  reportService: ReportService;
  authDataService: AuthDataService;
  $window: angular.IWindowService;
  notifyService: NotifyService;

  constructor(
    plantService: PlantService,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    notifyService: NotifyService,
    $q: angular.IQService,
    $window: angular.IWindowService) {

    this.loaderService = loaderService;
    this.reportService = reportService;
    this.authDataService = authDataService;
    this.notifyService = notifyService;
    this.$window = $window;

    this.reportDate = moment().clone().startOf('day').toDate();

    var selectedPlantId = null;
    var navPromise = navigationService.getNavigation().then((navModel) => {
      selectedPlantId = navModel.selectedPlant.id;
    });
    var plantsPromise = plantService.getPlants().then(plants => {
      this.plants = plants;
    });
    var promise = $q.all([navPromise, plantsPromise]).then(() => {
      this.selectedPlant = this.plants.filter(p => p.id === selectedPlantId)[0];
      this.updatePlant();
    });

    loaderService.loadingPromise(promise);
  }

  updatePlant() {
    this.shifts = this.selectedPlant.shiftSchedules.map((s,i) => {
      return {
        id: i + 1,
        name: s.name
      };
    });
    this.selectedShift = this.shifts[this.shifts.length-1];
  }

  getReport() {
    if (this.form.$invalid) {
      return;
    }

    this.loaderService.loadingPromise(this.runReport());
  }

  shiftChecked(shift:boolean){
    if(shift== true){
      this.selectedShift = this.shifts[this.shifts.length-1];
    }
  }

  private runReport(): angular.IPromise<any> {    
    var reportDate = DateUtilityService.localToTimeZone(this.reportDate, this.selectedPlant.timeZoneId).toDate();

    return this.reportService.getShiftDetailReport(
      this.selectedPlant.id,
      reportDate,
      this.selectedShift.id,
      this.allShifts
    ).then(html => {
      var newWindow = this.$window.open();
      newWindow.document.write(html);
    }, errors => {
      if (errors.status === 404) {
        this.notifyService.error("Report Not Found");
        return;
      }
      this.notifyService.handleApiErrors(errors);
    });
  }
}

export default angular.module('aps.controller.shiftDetailReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.SHIFT_DETAIL_REPORT,
      url: '/admin/reports/shiftDetail',
      controller: 'ShiftDetailReportControllerImplementation as vm',
      template: template,
      data: {
        pageTitle: 'Shift Detail Report'
      }
    });
  })
  .controller('ShiftDetailReportControllerImplementation', ShiftDetailReportControllerImplementation)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/reports/shiftDetailReport.controller.ts